import type { Conversation, ConversationDraft } from "../types";

export const startMessageEdit = (conversation: Conversation, messageId: string): Conversation => {
  const message = conversation.messages.find((item) => item.id === messageId && item.role === "user");
  if (!message) return conversation;
  return { ...conversation, draft: {
    content: message.content, attachments: message.attachments ?? [], editingMessageId: messageId,
    beforeEdit: conversation.draft?.beforeEdit ?? { content: conversation.draft?.content ?? "", attachments: conversation.draft?.attachments ?? [] },
  } };
};

export const cancelMessageEdit = (conversation: Conversation): Conversation => ({ ...conversation, draft: conversation.draft?.beforeEdit });

export const updateDraft = (conversation: Conversation, patch: Partial<ConversationDraft>): Conversation => ({
  ...conversation,
  draft: { content: "", attachments: [], ...conversation.draft, ...patch },
});

export const forkConversationAt = (conversation: Conversation, index: number, id: string, title: string, timestamp: string): Conversation => ({
  ...conversation, id, title, messages: conversation.messages.slice(0, index), draft: undefined,
  createdAt: timestamp, updatedAt: timestamp,
  parentConversationId: conversation.id,
  rootConversationId: conversation.rootConversationId ?? conversation.id,
  forkMessageId: conversation.messages[index]?.id,
  forkIndex: index,
  pinned: false, archivedAt: undefined, deletedAt: undefined,
  messagesLoaded: true,
});
